module.exports = __webpack_public_path__ + "img/plan-default-cover.c3c9d8aa.png";